import { uniq } from "lodash";

import { VehicleType } from "@busbud/int-schemas/lib/vehicles";

import type { VehicleLayoutTypeKey } from "@app/modules/results/state/filters-types";
import type { TranslatorService } from "@app/services/translator";
import type { NapiV2CartSegment } from "@app/types/napi-v2-cart-types";

export function getTranslatedVehicleType(
  vehicle_type: VehicleLayoutTypeKey | VehicleType | undefined | null,
  translator: TranslatorService
): string {
  switch (vehicle_type) {
    case VehicleType.Van:
      return translator.t("!common.vehicle-type.van");
    case VehicleType.Bus:
      return translator.t("!common.vehicle-type.bus");
    case VehicleType.Carpool:
      return translator.t("!common.vehicle-type.carpool");
    case VehicleType.Train:
      return translator.t("!common.vehicle-type.train");
    case VehicleType.Ferry:
      return translator.t("!common.vehicle-type.ferry");
    case VehicleType.Shuttle:
      return translator.t("!common.vehicle-type.shuttle");
    default:
      return translator.t("!common.vehicle-type.bus");
  }
}

export function getVehicleTypesFromTripSegments(
  trip_segments: NapiV2CartSegment[]
) {
  const vehicle_types = trip_segments.map(segment => {
    return segment.vehicle?.type || VehicleType.Bus;
  });

  return uniq(vehicle_types);
}
